import React, { useState } from 'react'; // <-- FIX: Import useState
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom'; // <-- FIX: Import useNavigate
import { Button } from 'antd';
import Navbar from '../sections/Navbar';
import Footer from '../sections/Footer';
import trainingData from '../data/training.json';
import ApplicationFormModal from '../components/ApplicationFormModal';


const ProgramDetailScreen = () => {
  const { programId } = useParams();
  const navigate = useNavigate(); // For the back button
  const program = trainingData.programs[programId];
  const [modalState, setModalState] = useState({
    isOpen: false,
    courseName: '',
    programName: '',
  });

  const handleApplyClick = (courseTitle) => {
    setModalState({ 
        isOpen: true, 
        courseName: courseTitle,
        programName: program.title 
    });
  };

  if (!program) {
    return <div>Program not found</div>; // Add a proper "Not Found" screen later
  }

  // Render the "Launch Program" layout
  // in frontend/src/screens/ProgramDetailScreen.js

// ... (imports and component logic)

  // Render the "Launch Program" layout
  if (programId === 'launch-program') {
    return (
      <>
        <Navbar />
        <div className="program-detail-page launch-program">
          <button onClick={() => navigate(-1)} className="back-button">
            &larr; Back to Programs
          </button>
          
          <header className="launch-program-header">
            <h1>{program.title}</h1>
            <p>{program.description}</p>

            {/* --- NEW: Single "Apply" button for the whole program --- */}
            <Button 
                className="launch-submit-request-btn"
                
                onClick={() => handleApplyClick(program.title)} // Applies for the main program title
                style={{ marginTop: '2rem' }} // Add some space above the button
            >
                Apply for this Program
            </Button>
          </header>
          
          {/* --- The Phased Timeline/Stepper --- */}
          <div className="phases-container">
            {program.phases.map((phase, index) => (
              <div key={phase.id} className={`phase-item ${!phase.available ? 'unavailable' : ''}`}>
                <div className="phase-number-container">
                  <div className="phase-number">{index + 1}</div>
                  {index < program.phases.length - 1 && <div className="phase-connector"></div>}
                </div>
                <div className="phase-content">
                  <h3>{phase.title}</h3>
                  <p>{phase.description}</p>
                  {/* --- REMOVED: The individual apply button is gone from here --- */}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <ApplicationFormModal
          open={modalState.isOpen}
          onClose={() => setModalState({ isOpen: false, courseName: '' })}
          courseName={modalState.courseName} // This will now be the main program title
          programName={program.title}
        />
        <Footer />
      </>
    );
  }

  // --- Render the "Brew Passion" layout ---
  if (programId === 'brew-passion') {
    return (
      <>
        <Navbar />
        <div className="program-detail-page">
          <button onClick={() => navigate(-1)} className="back-button">&larr; Back to Programs</button>
          <header className="launch-program-header">
              <h1>{program.title}</h1>
              <p>{program.description}</p>
          </header>
          <div className="course-grid">
            {program.courses.map(course => (
              <Link key={course.id} to={`/training/course/${course.id}`} state={{ programId: program.id }} className="course-card">
                <img src={course.image} alt={course.title} />
                <div className="course-card-content">
                  <h3>{course.title}</h3>
                  <span>{course.duration}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <Footer />
      </>
    );
  }
  
  // --- Render the "Professional Training" layout ---
  if (programId === 'professional') {
      return (
          <>
            <Navbar />
            <div className="program-detail-page professional-program">
                <button onClick={() => navigate(-1)} className="back-button">&larr; Back to Programs</button>
                <header className="launch-program-header">
                    <h1>{program.title}</h1>
                    <p>{program.description}</p>
                </header>

                {/* --- MODIFIED: Loop over the levels object --- */}
                {Object.entries(program.levels).map(([levelName, levelData]) => {
                    const levelIsAvailable = levelData.available; // <-- Directly read the 'available' property

                    return (
                        <div key={levelName} className={`level-section ${!levelIsAvailable ? 'unavailable-section' : ''}`}>
                            <h2>{levelName}</h2>
                            
                            {/* --- NEW: Display the level description --- */}
                            <p className="level-description">{levelData.description}</p>
                            
                            <div className="course-grid">
                                {/* Map over the courses within the levelData object */}
                                {levelData.courses.map(course => (
                                    <Link key={course.id} to={`/training/course/${course.id}`} state={{ programId: program.id }} className="course-card">
                                        <img src={course.image} alt={course.title} />
                                        <div className="course-card-content">
                                            <h3>{course.title}</h3>
                                            <span>{course.duration}</span>
                                        </div>
                                        {/* The lock icon can be removed since the whole section will be styled as unavailable */}
                                    </Link>
                                ))}
                            </div>
                            
                            <div className="level-apply-button-container">
                                <Button 
                                    className="submit-request-btn"
                                    type="primary"
                                    onClick={() => handleApplyClick(levelName)}
                                    disabled={!levelIsAvailable} // <-- Logic is now simpler
                                >
                                    {levelIsAvailable ? `Apply for ${levelName} Level` : 'Level Locked'}
                                </Button>
                            </div>
                        </div>
                    );
                })}
            </div>
            <ApplicationFormModal
                open={modalState.isOpen}
                onClose={() => setModalState({ isOpen: false, courseName: '' })}
                courseName={modalState.courseName} // This will be the level name (e.g., "Beginner")
                programName={program.title}
            />
            <Footer />
          </>
      )
  }

  return null;
};

export default ProgramDetailScreen;